import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "page",
    component: () => import("../views/page.vue"),
    redirect: {
      name: "home",
    },
    children: [
      {
        path: "",
        name: "home",
        meta: {
          title: "首页",
        },
        component: () => import("../views/home.vue"),
      },
      {
        path: "transport",
        name: "transport",
        meta: {
          title: "海铁联运",
        },
        component: () => import("../views/transport.vue"),
        redirect: {
          name: "transportBooking",
        },
        children: [
          {
            path: "booking",
            name: "transportBooking",
            meta: {
              title: "海运订舱",
            },
            component: () => import("../views/transport/booking.vue"),
          },
          {
            path: "box",
            name: "transportBox",
            meta: {
              title: "用箱服务",
            },
            component: () => import("../views/transport/box.vue"),
          },
          {
            path: "document",
            name: "transportDocument",
            meta: {
              title: "单证服务",
            },
            component: () => import("../views/transport/document.vue"),
          },
          {
            path: "logistics",
            name: "transportLogistics",
            meta: {
              title: "物流追踪",
            },
            component: () => import("../views/transport/logistics/index.vue"),
            redirect: {
              name: "transportLogisticsHuangdao",
            },
            children: [
              {
                path: "huangdao",
                name: "transportLogisticsHuangdao",
                meta: {
                  title: "黄岛港站",
                },
                component: () => import("../views/transport/logistics/huangdao/index.vue"),
              },
              {
                path: "inland",
                name: "transportLogisticsInland",
                meta: {
                  title: "内陆港",
                },
                component: () => import("../views/transport/logistics/inland.vue"),
              },
              {
                path: "station",
                name: "transportLogisticsStation",
                meta: {
                  title: "场站",
                },
                component: () => import("../views/transport/logistics/station.vue"),
              },
            ]
          }
        ]
      },
      {
        path: "about",
        name: "about",
        meta: {
          title: "关于我们",
        },
        component: () => import("../views/about.vue"),
      },
      {
        path: "support",
        name: "support",
        meta: {
          title: "帮助与支持",
        },
        component: () => import("../views/support.vue"),
      },
      {
        path: "customer",
        name: "customer",
        meta: {
          title: "客户中心",
        },
        component: () => import("../views/customer.vue"),
      },
    ]
  },
  {
    path: "/codeCallback",
    name: "codeCallback",
    meta: {
      title: "加载中...",
    },
    component: () => import("../views/codeCallback.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
